import React from 'react';

import PropTypes from 'prop-types';

import { logger } from 'utils/logger';

/** Shows `fallback` instead of a field renderer that threw, so one bad value never blanks the row. */
class AuditFieldValueBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error(error, errorInfo);
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

AuditFieldValueBoundary.propTypes = {
  fallback: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuditFieldValueBoundary;
